import classNames from "classnames";
import React, { ReactNode } from "react";

import { HeadingText } from "styles";

type Props = {
  children: ReactNode;
  className?: string;
};

export const PageSectionTitle = (props: Props) => {
  const { children, className } = props;

  return (
    <HeadingText
      $variant="heading03"
      as="h3"
      className={classNames(className, "pb-4")}
    >
      {children}
    </HeadingText>
  );
};
